import React from 'react';
import { motion } from 'framer-motion';
import { FiSend } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ContactCTA = () => {
  return (
    <section id="contact" className="py-32 bg-slate-950 px-6">
      <div className="max-w-4xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          className="bg-indigo-600 rounded-[3rem] p-12 md:p-20 relative overflow-hidden shadow-2xl shadow-indigo-600/30"
        >
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
          <div className="relative z-10 text-center">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6 tracking-tighter italic uppercase">Contact VideoNation</h2>
            <p className="text-indigo-100 text-lg mb-10 max-w-md mx-auto font-medium">
              Connect with our team to discuss your call volume requirements.
            </p>
            
            <form className="max-w-lg mx-auto space-y-4" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Work Email Address" 
                className="w-full bg-white/10 border border-white/20 rounded-2xl px-6 py-5 text-white placeholder:text-indigo-200 focus:outline-none focus:ring-2 focus:ring-white/50 transition-all text-center font-bold"
              />
              <button className="w-full bg-white text-indigo-600 font-black py-5 rounded-2xl hover:bg-slate-950 hover:text-white transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 tracking-widest">
                SEND MESSAGE <SafeIcon icon={FiSend} />
              </button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactCTA;